import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FaRegCopy } from 'react-icons/fa';

const Modal = ({ isOpen, imageSrc, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
      <div className="relative bg-white rounded-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-lg text-red-500"
        >
          ✖
        </button>
        <img
          src={imageSrc}
          alt="Schematic"
          className="object-cover rounded-lg shadow-lg cursor-pointer"
          style={{ height: '250px', width: '250px' }}
        />
      </div>
    </div>
  );
};

const Schematics = ({ procedure }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const hasImages = procedure?.images?.length > 0;

  const openModal = src => {
    setSelectedImage(src);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedImage(null);
  };

  const copyToClipboard = text => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard!');
    });
  };

  function splitFilename(filename) {
    const lastDotIndex = filename?.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return { name: filename, extension: '' };
    }

    const name = filename?.substring(0, lastDotIndex);

    return name;
  }

  return (
    <section id="schematics" className="mb-12">
      <h2 className="text-2xl font-bold mb-4">Schematics</h2>
      {hasImages ? (
        <div>
          <ul className="list-disc list-inside">
            {procedure.images.map((item, index) => (
              <li key={index} className="flex items-center space-x-2">
                <a
                  onClick={() => openModal(item.src)}
                  className="cursor-pointer text-blue-500 hover:underline"
                >
                  {splitFilename(item?.name)}
                </a>
                <button
                  onClick={() => copyToClipboard(item?.src)}
                  className="relative group ml-2 text-gray-600 border border-gray-300 rounded p-1 hover:bg-gray-100"
                  aria-label="Copy link"
                  title="Click to copy link"
                >
                  <FaRegCopy />
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-center text-gray-500">No schematics available.</p>
      )}
      <Modal isOpen={isOpen} imageSrc={selectedImage} onClose={closeModal} />
    </section>
  );
};

export default Schematics;
